var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.455 9.831l-2.56-6.387c-.45-1.088.325-2.343 1.198-1.937l15.16 7.062c.807.374.827 1.903.032 2.3L4.09 18.484c-.838.42-1.64-.745-1.268-1.841l1.527-4.504c.474-1.397 1.507-2.296 2.65-2.308H13",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var MemoSvgSend = /*#__PURE__*/React.memo(SvgSend);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNDU0NTcgOS44MzEwOEwyLjg5NTE3IDMuNDQzOTlDMi40NDQ5IDIuMzU1NjcgMy4yMjAxNSAxLjEwMTQxIDQuMDkzMjkgMS41MDY2M0wxOS4yNTM4IDguNTY5MUMyMC4wNjA0IDguOTQzNDUgMjAuMDggMTAuNDcxNyAxOS4yODUxIDEwLjg2OTJMNC4wODkzOCAxOC40ODM2QzMuMjUxNDcgMTguOTA0MiAyLjQ0ODgxIDE3LjczODcgMi44MjA3OCAxNi42NDI3TDQuMzQ3NzkgMTIuMTM4OUM0LjgyMTU2IDEwLjc0MTkgNS44NTUyMyA5Ljg0MjY2IDYuOTk4NTMgOS44MzEwOEgxMyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { MemoSvgSend as ReactComponent };